module.exports = __webpack_public_path__ + "img/card.66c3bdf1.png";